/** True when Redux list payload can be reused for this auction (skip API). */
export function canReuseAuctionList(pageData, aid) {
  if (!pageData || pageData === 0 || !pageData.responsedata) return false;
  const cachedAid = pageData.responsedata.aid;
  if (cachedAid == null || cachedAid === "") return true;
  return String(cachedAid) === String(aid);
}

/** Ensure responsedata carries aid so later mounts can reuse it. */
export function withAuctionAid(responsedata, aid) {
  if (!responsedata || typeof responsedata !== "object") return responsedata;
  if (responsedata.aid == null || responsedata.aid === "") {
    return { ...responsedata, aid };
  }
  return responsedata;
}
